<section class="position-relative">
    @if (!body()?.primary?.video?.length) {
    <img
        loading="eager"
        fetchpriority="high"
        [src]="body()?.primary?.image?.url || body()?.items?.[0]?.image?.url"
        [alt]="body()?.primary?.image?.alt || body()?.items?.[0]?.image?.alt"
        class="rounded-borders-top media"
    />
    <div class="overlay"></div>
    <ng-container *ngTemplateOutlet="content"> </ng-container>
    } @else {
    <video
        #videoPlayer
        [id]="body()?.id"
        [poster]="body()?.primary.image?.url"
        onloadedmetadata="this.muted=true"
        preload="metadata"
        playsinline="playsinline"
        muted="muted"
        loop="loop"
        autoplay
        class="media"
    >
        <source [src]="'assets/videos/' + body()?.primary.video" type="video/mp4" />
    </video>
    <div class="overlay"></div>
    <ng-container *ngTemplateOutlet="content"> </ng-container>
    }
</section>

<ng-template #content>
    <div class="section-content d-flex">
        <div class="container m-auto">
            <div class="row">
                <div class="col-12 text-center">
                    <h1 class="heading color-white">{{ body()?.primary?.heading }}</h1>
                    <div [innerHTML]="body().primary?.title | renderHtml : htmlSerializer"></div>
                    @if (!body()?.primary?.disable_apply_form){
                    <ng-container *ngTemplateOutlet="applyForm"></ng-container>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="divider background-white z-2"></div>
</ng-template>

<ng-template #applyForm>
    <div class="mt-5">
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <div class="apply-form background-white p-4 p-lg-0">
                    <div class="row">
                        <div class="col-lg mb-3 mb-lg-0 px-lg-4">
                            <div class="form-floating my-1 ms-lg-2 d-flex align-items-center">
                                <input id="name" type="text" class="form-control border-0" placeholder="Dein Name" [(ngModel)]="name" />
                                <label for="name">👋 Dein Name</label>
                            </div>
                        </div>

                        <div class="col-lg mb-3 mb-lg-0 px-lg-4 d-flex align-items-center">
                            <div class="form-floating w-100">
                                <input
                                    id="email"
                                    type="text"
                                    class="form-control border-0"
                                    placeholder="Deine E-Mail"
                                    [(ngModel)]="email"
                                />
                                <label for="email">✉️ Deine E-Mail</label>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="d-flex justify-content-end h-100">
                                <button class="btn btn-black align-items-center w-100" (click)="openApplicationModal($event)">
                                    <span>Jetzt bewerben</span>
                                    <img src="assets/images/arrow-right-white.svg" alt="Pfeil nach rechts" class="ms-3 icon-small" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (body()?.items?.length) {
                <div class="col-12 text-center d-flex justify-content-center align-items-center flex-wrap gap-3 gap-lg-5 mt-5">
                    <span class="color-white fw-bold text-uppercase d-flex align-items-center" style="font-size: 15px; line-height: 1.2;">Bekannt aus</span>
                    @for (logo of body()?.items; track $index) {
                        <img class="trust-logo" [src]="logo?.trust_element?.url" [alt]="logo?.trust_element?.alt"/>
                    }
                </div>
            }
        </div>
    </div>
</ng-template>
